var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagForUnitedKingdom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40003902_15144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 16.875H16.875C17.4929 16.875 18.0179 16.7356 18.4538 16.4928L11.875 12.5684V16.875ZM19.8938 14.4406C19.965 14.1228 20.0013 13.7863 20.0013 13.4372V11.8747H15.5919L19.8925 14.4406M0.109417 5.54969C0.0352653 5.88215 -0.00142164 6.22187 4.2126e-05 6.5625V8.125H4.42629L0.109417 5.54969ZM8.12504 3.125H3.12504C2.5116 3.125 1.99004 3.2625 1.55598 3.50188L8.12504 7.42063V3.125ZM1.57598 16.5081C2.00598 16.7406 2.52067 16.875 3.12504 16.875H8.12504V12.6013L1.57598 16.5081ZM4.2126e-05 11.875V13.4375C4.2126e-05 13.7972 0.0381671 14.1438 0.11348 14.4697L4.46317 11.875H4.2126e-05ZM18.4735 3.51719C18.0341 3.26781 17.5019 3.125 16.875 3.125H11.875V7.45344L18.4735 3.51719ZM20 8.125V6.5625C20 6.22062 19.9647 5.89094 19.8963 5.57906L15.6288 8.125H20Z",
    fill: "#2E3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6287 8.125L19.8962 5.57906C19.7006 4.68406 19.2244 3.94313 18.4734 3.51719L11.875 7.45344V3.125H11.25V8.75H20V8.125H15.6287ZM0 11.25V11.875H4.46312L0.113438 14.4697C0.32 15.3619 0.810625 16.0944 1.57594 16.5081L8.125 12.6013V16.875H8.75V11.25H0ZM20 11.25H11.25V16.875H11.875V12.5684L18.4537 16.4931C19.2103 16.0719 19.6925 15.335 19.8925 14.4413L15.5919 11.875H20V11.25ZM8.125 3.125V7.42063L1.55594 3.50188C0.796562 3.92063 0.31125 4.65625 0.109063 5.54969L4.42625 8.125H0V8.75H8.75V3.125H8.125Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.75V3.125H8.75V8.75H0V11.25H8.75V16.875H11.25V11.25H20V8.75H11.25Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85563 8.12488L0.59 4.38457C0.455313 4.58457 0.347188 4.80457 0.257812 5.03895L5.42875 8.12488H6.85469M19.7156 15.028L14.4616 11.8749H13.0066L19.3544 15.6933C19.5012 15.4874 19.6225 15.2644 19.7156 15.0293M18.9747 3.87207L11.8653 8.12488L13.3088 8.12582L19.4434 4.45301C19.3066 4.20395 19.1622 4.04332 18.9747 3.87207ZM0.566563 15.5858C0.707147 15.7999 0.876315 15.9938 1.06938 16.1621L8.14469 11.8749H6.71875L0.566563 15.5858Z",
    fill: "#BE1E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40003902_15144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForUnitedKingdom);
export default __webpack_public_path__ + "static/media/flag-for-united-kingdom.bdcf70295ef3e26fe821c0c0b460c574.svg";
export { ForwardRef as ReactComponent };